module.exports = __webpack_public_path__ + "img/WORDIcon.8b59e1ff.jpg";